/* BioLuxea pre-registration funnel.
   Shopify's native customer form remains the system of record. This script adds
   line preselection, first/latest-touch attribution tags, accessible form state,
   spam friction and privacy-safe funnel events. It never records an email address. */
(() => {
  const form = document.getElementById('BioLuxeaWaitlist');
  const choice = document.getElementById('blx-waitlist-line');
  const section = document.querySelector('[data-blx-waitlist]');
  if (!form || !section) return;

  const tagField = document.getElementById('blx-waitlist-tags');
  const honeypot = form.querySelector('[data-blx-honeypot]');
  const submitButton = form.querySelector('[data-blx-submit]');
  const submitLabel = form.querySelector('[data-blx-submit-label]');
  const locale = document.documentElement.lang.toLowerCase().startsWith('en') ? 'en' : 'nl';
  const formVersion = section.dataset.formVersion || 'unknown';
  const formLoadTimestamp = Date.now();
  const submissionId = globalThis.crypto?.randomUUID?.() || `blx-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const values = {
    'home-line': 'newsletter,bioluxea-prelaunch,home-line',
    'salon-line': 'newsletter,bioluxea-prelaunch,salon-line',
    'hand-set': 'newsletter,bioluxea-prelaunch,hand-set',
    both: 'newsletter,bioluxea-prelaunch,home-line,salon-line'
  };

  const clean = (value, max = 80) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, max);

  const safeJSON = (storage, key) => {
    try {
      return JSON.parse(storage.getItem(key) || '{}');
    } catch (_error) {
      return {};
    }
  };

  const currentTouch = {};
  const search = new URLSearchParams(window.location.search);
  attributionKeys.forEach(key => {
    const value = clean(search.get(key));
    if (value) currentTouch[key] = value;
  });
  const referrerHost = (() => {
    try {
      const host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : '';
      return host && host !== window.location.hostname ? clean(host, 50) : '';
    } catch (_error) {
      return '';
    }
  })();
  if (referrerHost) currentTouch.referrer = referrerHost;

  let firstTouch = {};
  let latestTouch = currentTouch;
  try {
    firstTouch = safeJSON(localStorage, 'blx_first_touch');
    if (!Object.keys(firstTouch).length && Object.keys(currentTouch).length) {
      localStorage.setItem('blx_first_touch', JSON.stringify(currentTouch));
      firstTouch = currentTouch;
    }
    if (Object.keys(currentTouch).length) sessionStorage.setItem('blx_latest_touch', JSON.stringify(currentTouch));
    latestTouch = Object.keys(currentTouch).length ? currentTouch : safeJSON(sessionStorage, 'blx_latest_touch');
  } catch (_error) {
    firstTouch = currentTouch;
  }

  const lineFromValue = value => {
    if (!value) return 'none';
    if (value.includes('hand-set')) return 'hand-set';
    if (value.includes('home-line') && value.includes('salon-line')) return 'both';
    if (value.includes('home-line')) return 'home-line';
    if (value.includes('salon-line')) return 'salon-line';
    return 'none';
  };

  const pageType = (() => {
    const path = window.location.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    if (path === '/') return 'home';
    if (path.includes('/pages/professionals')) return 'salon-line';
    if (path.includes('/pages/home-line')) return 'home-line';
    if (path.includes('/pages/productinformatie')) return 'product-information';
    if (path.includes('/pages/veelgestelde-vragen')) return 'faq';
    if (path.includes('/blogs/')) return 'content';
    if (path.includes('/products/')) return 'legacy-product';
    return 'other';
  })();

  const baseEvent = () => ({
    form_id: 'BioLuxeaWaitlist',
    form_name: 'bioluxea_pre_registration',
    form_version: formVersion,
    language: locale,
    line_preference: lineFromValue(choice?.value),
    page_type: pageType,
    page_location: window.location.pathname,
    submission_id: submissionId,
    utm_source: latestTouch.utm_source || firstTouch.utm_source || '',
    utm_medium: latestTouch.utm_medium || firstTouch.utm_medium || '',
    utm_campaign: latestTouch.utm_campaign || firstTouch.utm_campaign || ''
  });

  const publish = (eventName, extra = {}) => {
    const payload = { ...baseEvent(), ...extra };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
    try {
      window.Shopify?.analytics?.publish?.(eventName, payload);
    } catch (_error) {
      // dataLayer and the DOM event remain available if Shopify rejects a custom event.
    }
    document.dispatchEvent(new CustomEvent(`bioluxea:${eventName}`, { detail: payload }));
  };

  const ctaLocation = link => {
    if (link.closest('.blx-home-hero')) return 'hero';
    if (link.closest('.blx-home-product')) return 'product-card';
    if (link.closest('.blx-launch-header')) return 'header';
    if (link.closest('.blx-launch-banner')) return 'announcement';
    if (link.closest('.blx-launch-footer')) return 'footer';
    if (link.closest('.blx-editorial')) return 'editorial';
    return 'other';
  };

  const selectLine = (line, source = 'direct') => {
    if (!choice || !Object.prototype.hasOwnProperty.call(values, line)) return;
    choice.value = values[line];
    choice.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { source } }));
  };

  if (choice) selectLine(search.get('lijn'), 'campaign-link');

  let formStarted = false;
  const markStarted = event => {
    if (formStarted) return;
    formStarted = true;
    publish('form_start', { field_name: event.target?.id || 'unknown' });
  };
  form.addEventListener('input', markStarted, { once: true });
  form.addEventListener('change', markStarted, { once: true });

  choice?.addEventListener('change', event => {
    publish('line_selected', {
      selection_source: event.detail?.source || 'form',
      line_preference: lineFromValue(choice.value)
    });
  });

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="#aanmelden"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    publish('waitlist_cta_click', {
      cta_location: ctaLocation(link),
      requested_line: link.dataset.blxLine || 'none'
    });

    if (!link.dataset.blxLine || !choice) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.hash !== '#aanmelden') return;
    event.preventDefault();
    selectLine(link.dataset.blxLine, ctaLocation(link));
    document.querySelector('.blx-launch-menu[open]')?.removeAttribute('open');
    section.scrollIntoView({ behavior: 'auto', block: 'start' });
    choice.focus({ preventScroll: true });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      publish('form_view');
      observer.disconnect();
    }, { threshold: 0.35 });
    observer.observe(section);
  } else {
    publish('form_view');
  }

  form.addEventListener('submit', event => {
    if (honeypot?.value) {
      event.preventDefault();
      publish('form_submit_error', { error_code: 'spam_honeypot' });
      return;
    }

    const selectedLine = lineFromValue(choice?.value);
    const tags = new Set(String(choice?.value || '').split(',').map(tag => tag.trim()).filter(Boolean));
    tags.add(`language-${locale}`);
    tags.add(`landing-${pageType}`);
    tags.add(`form-${formVersion}`);
    tags.add('consent-launch-email');
    tags.add('consent-text-2026-09-01');
    tags.add(`signup-${new Date().toISOString().slice(0, 7)}`);

    const tagTouch = Object.keys(firstTouch).length ? firstTouch : latestTouch;
    const tagMap = {
      utm_source: 'source',
      utm_medium: 'medium',
      utm_campaign: 'campaign',
      utm_content: 'content'
    };
    Object.entries(tagMap).forEach(([key, prefix]) => {
      const value = clean(tagTouch[key], 28);
      if (value) tags.add(`${prefix}-${value}`);
    });
    if (!tagTouch.utm_source && tagTouch.referrer) tags.add(`referrer-${clean(tagTouch.referrer, 28)}`);
    if (!tagTouch.utm_source && !tagTouch.referrer) tags.add('source-direct');

    if (choice && tagField) {
      choice.name = 'line_preference';
      tagField.name = 'contact[tags]';
      tagField.value = Array.from(tags).join(',');
    }

    publish('form_submit', {
      line_preference: selectedLine,
      elapsed_ms: Date.now() - formLoadTimestamp,
      attribution_tags: Array.from(tags).filter(tag => /^(source|medium|campaign|content|referrer)-/.test(tag)).join(',')
    });
    if (submitButton && submitLabel) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitLabel.textContent = submitButton.dataset.busyLabel || submitLabel.textContent;
    }
  });

  const success = form.querySelector('[data-blx-waitlist-success]');
  const error = form.querySelector('[data-blx-waitlist-error]');
  if (success) {
    publish('form_submit_success', { server_confirmed: true });
    success.focus({ preventScroll: true });
  }
  if (error) publish('form_submit_error', { error_code: 'shopify_customer_form', server_confirmed: true });
})();
